<msc-link-preview *ngFor="let link of links" [link]="link" [class]="class"></msc-link-preview>
